/**
 * MELANUA Preview Mode Context
 * TEMPORARY: Hides prices until launch. Remove before go-live.
 * Access with: ?key=melanua2026
 */

import React, { createContext, useContext, useState, useEffect } from 'react';

const PreviewContext = createContext(null);

const SECRET_KEY = 'melanua2026';

export function PreviewProvider({ children }) {
    const [isPreviewMode, setIsPreviewMode] = useState(() => {
        // Check on initial render
        if (typeof window !== 'undefined') {
            const params = new URLSearchParams(window.location.search);
            if (params.get('key') === SECRET_KEY) {
                sessionStorage.setItem('melanua_preview', 'true');
                return true;
            }
            return sessionStorage.getItem('melanua_preview') === 'true';
        }
        return false;
    });

    // Check URL on mount and navigation
    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        if (params.get('key') === SECRET_KEY) {
            sessionStorage.setItem('melanua_preview', 'true');
            setIsPreviewMode(true);
        }
    }, []);

    const value = {
        isPreviewMode,  // true = can see prices, false = prices hidden
        enablePreview: () => {
            sessionStorage.setItem('melanua_preview', 'true');
            setIsPreviewMode(true);
        }
    };

    return (
        <PreviewContext.Provider value={value}>
            {children}
        </PreviewContext.Provider>
    );
}

export function usePreview() {
    const context = useContext(PreviewContext);
    if (!context) {
        throw new Error('usePreview must be used within a PreviewProvider');
    }
    return context;
}

// Helper component to show price or "Coming Soon"
export function Price({ amount, className = '' }) {
    const { isPreviewMode } = usePreview();

    if (!isPreviewMode) {
        return <span className={className}>Price TBA</span>;
    }

    const formatted = typeof amount === 'number'
        ? amount.toFixed(2)
        : parseFloat(amount).toFixed(2);

    return <span className={className}>${formatted}</span>;
}

export default PreviewContext;
